import React, { type FC, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';

import { type ContentData } from './types';

import { VerificationCode } from 'app/design-system/components/VerificationCode';
import { Theme, useTheme } from 'app/lib/theme';

import { CodeConfirmationActions } from './CodeConfirmationActions/CodeConfirmationActions';
import { CODE_LENGTH } from './constants';
import { getDataGaEventBySearchParams } from './utils';

import styles from './CodeConfirmation.module.scss';

type ContentProps = {
  data: ContentData;
};

export const Content: FC<ContentProps> = ({ data }) => {
  const { search } = useLocation();
  const { resentDataEvent, changeDataEvent } = getDataGaEventBySearchParams(search);

  const {
    changeVerifyData,
    codeResendInfo,
    error,
    touched,
    changeValue,
    onFocus,
    onChange,
    value,
    title,
  } = data;

  const { theme } = useTheme();

  const confirmCodeInputClassNames = classNames(styles.confirmCodeInput, {
    [styles.dark]: theme === Theme.DARK,
    [styles.light]: theme === Theme.LIGHT,
  });

  const handleChangeDataButton = useCallback(() => {
    changeVerifyData();
  }, [changeVerifyData]);

  const ref = React.useRef() as React.MutableRefObject<HTMLInputElement>;

  useEffect(() => {
    if (touched && ref.current) {
      ref.current.blur();
    }
  }, [touched, ref.current]);

  return (
    <>
      <p className={styles.fieldInfoSendCode}>{title}</p>

      <VerificationCode
        onChange={onChange}
        value={value}
        length={CODE_LENGTH}
        className={confirmCodeInputClassNames}
        data-test="Modal-codeConfirmation-input"
        autoFocus
        onFocus={onFocus}
        isError={!!error} />

      <CodeConfirmationActions dataGaEvent={resentDataEvent}
                               changeValue={changeValue}
                               changeDataEvent={changeDataEvent}
                               handleChangeDataButton={handleChangeDataButton}
                               error={error}
                               codeResendInfo={codeResendInfo} />

    </>
  );
};
